<section>
  <div class="tw-flex">
    <form-field
      [(value)]="model"
      [control]="form?.get('resellerDomain')"
      [label]="fields + 'resellerDomain'"
      classList="dir-ltr"
      class="tw-w-full"
      (change)="emitResellerDomain()"
    >
    </form-field>
    <div class="md:tw-w-1/12 tw-flex-center">
      <button
        class="mat-ripple btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-danger"
        (click)="onRemoveResellerDomain(index)"
      >
        -
      </button>
    </div>
  </div>
</section>
